import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, HStack, Text, VStack } from "native-base";
import { useEffect, useState } from "react";
import { InsulinType } from "@madmedical/medical";
import { useFormContext } from "@madmedical/form";
import { invariant } from "@madmedical/utils";
import { useTranslation } from "@madmedical/i18n";
import SubmitButton from "../form/SubmitButton";
import DateTimeInput from "../form/DateTimeInput";
import Button from "../atoms/Button";
import ModalContent from "../molecules/ModalContent";
import FormSelect from "../form/FormSelect";
import FormControl from "../form/FormControl";
import { formatType, generateInsulinBodyLocations, } from "../util/insulinFormatters";
import { useInsulinAdministration } from "../providers/insulinAdministration";
import useResponsive from "../util/useResponsive";
import FormTextAreaControl from "../form/FormTextAreaControl";
const InsulinAdministrationModalForm = ({ onClose, onSubmitPress, isSuccess, isEdit = false, }) => {
    const { isSmallScreen } = useResponsive();
    const [isValid, setIsValid] = useState(false);
    useEffect(() => {
        if (isSuccess) {
            onClose();
        }
    }, [isSuccess, onClose]);
    const { products } = useInsulinAdministration();
    const insulinTypes = [
        { value: InsulinType.Rapid, label: formatType(InsulinType.Rapid) },
        { value: InsulinType.Basal, label: formatType(InsulinType.Basal) },
        { value: InsulinType.Other, label: formatType(InsulinType.Other) },
    ];
    const { setValue, getValues, unregister, watch } = useFormContext();
    const chosenInsulinType = watch("insulinType");
    const chosenInsulinProduct = watch("productId");
    const enteredInsulinUnit = watch("units");
    const chosenBodyLocation = watch("bodyLocationSelector");
    invariant(products, "No products found");
    const insulinProducts = products
        .filter((item) => item.type === chosenInsulinType)
        .map((product) => ({
        value: product.id,
        label: product.name,
    }));
    const insulinDeliveryPlaces = generateInsulinBodyLocations();
    useEffect(() => {
        if (chosenInsulinType &&
            chosenInsulinProduct &&
            enteredInsulinUnit &&
            enteredInsulinUnit > 0 &&
            chosenBodyLocation) {
            setIsValid(true);
        }
        else {
            setIsValid(false);
        }
    }, [
        chosenInsulinType,
        chosenInsulinProduct,
        enteredInsulinUnit,
        chosenBodyLocation,
    ]);
    useEffect(() => {
        if (isEdit) {
            const { bodyLocation, product } = getValues();
            setValue("bodyLocationSelector", `${bodyLocation.bodyPart}-${bodyLocation.side}`);
            if (product) {
                setValue("insulinType", product === null || product === void 0 ? void 0 : product.type);
                setValue("productId", product === null || product === void 0 ? void 0 : product.id);
            }
        }
    }, [isEdit, setValue, getValues]);
    const onSubmit = () => {
        const { bodyLocationSelector } = getValues();
        const [bodyPart, side] = bodyLocationSelector.split("-");
        setValue("bodyLocation", {
            bodyPart,
            side,
        });
        unregister("bodyLocationSelector", {
            keepIsValid: true,
        });
        onSubmitPress();
    };
    const { t } = useTranslation();
    return (_jsx(ModalContent, Object.assign({ header: `Inzulin beadás ${isEdit ? t("editing") : t("recording")}`, footer: _jsxs(_Fragment, { children: [_jsx(Button, Object.assign({ onPress: onClose, variant: "outlined" }, { children: t("cancel") })), _jsx(SubmitButton, { onPress: onSubmit, label: t("save"), isDisabled: !isValid })] }) }, { children: _jsxs(VStack, { children: [_jsx(DateTimeInput, { name: "administeredAt", isRequired: true, label: t("appointment") }), _jsxs(HStack, Object.assign({ space: 2, mt: 2, direction: isSmallScreen ? "column" : "row" }, { children: [_jsx(FormSelect, { choices: insulinTypes.map((type) => ({
                                value: type.value,
                                label: type.label,
                            })), name: "insulinType", label: "Inzulin t\u00EDpusa", labelProps: { _text: { color: "gray.800" } } }), _jsx(FormSelect, { choices: insulinProducts, name: "productId", label: "Inzulin term\u00E9k", labelProps: { _text: { color: "gray.800" } } })] })), _jsxs(HStack, Object.assign({ space: 2, mt: 2, direction: isSmallScreen ? "column" : "row" }, { children: [_jsx(FormControl, { label: "Mennyis\u00E9g", name: "units", labelProps: {
                                _text: { color: "gray.800" },
                            }, type: "number", height: 35, maxLength: 2, InputRightElement: _jsx(Box, Object.assign({ px: 2 }, { children: _jsx(Text, Object.assign({ color: "gray.500", fontSize: "xs" }, { children: "Egys\u00E9g" })) })) }), _jsx(FormSelect, { choices: insulinDeliveryPlaces, name: "bodyLocationSelector", label: "Bead\u00E1si hely", labelProps: { _text: { color: "gray.800" } } })] })), _jsx(Box, Object.assign({ mt: 2 }, { children: _jsx(FormTextAreaControl, { label: t("comment"), name: "comment", labelProps: {
                            _text: { color: "gray.800" },
                        }, maxLength: 100, textareaHeight: 75 }) }))] }) })));
};
export default InsulinAdministrationModalForm;
